import { useEffect, useRef } from "react";

// DR-DATA Fahrzeug-Konfigurator (adaptive height via postMessage, base height 180px).
const SRC =
  "https://konf.dr-file.de/index.php?lic=39hfudhgf67382364&origin=dr-file.de&theme=custom&make=Audi&model=A7&gen=4G%202010%20-%202014&engine=3.0%20TDI%20Bi-Turbo%20313hp&lang=de&bg=transparent&text=%23ffffff&accent=%23fff700&pulse=%23ffea00&pulseOff=0&dyno=1&dynoBg=%230a0a0a&dynoText=%23ffffff&dynoAccent=%23ffd500&design=v2";

export default function Konfigurator() {
  const ref = useRef(null);

  useEffect(() => {
    const iframe = ref.current;
    if (iframe && !iframe.src) iframe.src = SRC;

    const onMessage = (e) => {
      if (e.data?.type === "resize" && ref.current) {
        const h = e.data.height;
        requestAnimationFrame(() => {
          if (ref.current) ref.current.style.height = h + "px";
        });
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <iframe
      ref={ref}
      id="fahrzeug-konfigurator"
      title="Fahrzeug-Konfigurator"
      data-testid="fahrzeug-konfigurator"
      scrolling="no"
      loading="lazy"
      style={{
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        border: "none",
        display: "block",
        height: "180px",
      }}
    />
  );
}
